import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import SuccessRoute from './routes/SuccessRoute';

// Lazy load heavy components for better initial load performance
const Signup = React.lazy(() => import('./features/Signup/components'));
const SignupSuccess = React.lazy(() => import('./features/Signup/components/SignupSuccess'));
const Profile = React.lazy(() => import('./features/Profile'));

// Loading fallback component
const PageLoader = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
    </Box>
);

const AppRoutes = () => {
    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <Signup />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/success"
                    element={
                        <SuccessRoute>
                            <SignupSuccess />
                        </SuccessRoute>
                    }
                />
                <Route
                    path="/profile"
                    element={
                        <PrivateRoute>
                            <Profile />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;